import { Component } from '@angular/core'; 
import { Router } from '@angular/router';
import { VariantType } from 'app/models/variantTypes.models';
import { VariantTypesService } from 'app/services/variant-types.service';

@Component({
  selector: 'app-tipo-variante',
  templateUrl: './tipo-variante.component.html',
  styleUrls: ['./tipo-variante.component.css']
})
export class TipoVarianteComponent {
  tipovariantes = [];

  constructor(
     private variantTypeService: VariantTypesService,
     private router: Router
  ) { }

  ngOnInit(): void {
    const sidebar = <HTMLElement>document.querySelector(".navbar-brand");
    if (sidebar !== undefined) {
      sidebar.innerHTML = "Configuraciones";
    }
    this.getVariantTypes();
  }

  getVariantTypes() {
    this.tipovariantes = [];
    this.variantTypeService.getVariantTypes().subscribe(
      (data: any) => {
        this.tipovariantes = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  editTvariante(tvariante:VariantType) {
    this.router.navigate(['/configurar/tipovariante/edit', tvariante.id]);
  }

  deleteTvariante(tvariante:VariantType) {
    this.variantTypeService.deleteVariantType(tvariante.id).subscribe(
      (data: any) => {
        this.getVariantTypes();
      },
      (error) => {
        console.log(error);
      }
    );
  }

}
